import { render, staticRenderFns } from "./CsConsultaDetalle.vue?vue&type=template&id=56c79758"
import script from "./CsConsultaDetalle.vue?vue&type=script&lang=js"
export * from "./CsConsultaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports